<template>
	<div class="insideBody">
		<div class="studyReport">
			
			<div class="main">
				
				<div class="conTop on clr">
					<div class="export fr">导出学习报告</div>
				</div>
				
				<div class="data_top">
					<ul>
						<li class="li1">
							<div class="tit">共学课文</div>
							<div class="text"><span>21</span>篇</div>
						</li>
						<li class="li2">
							<div class="tit">总学习时长</div>
							<div class="text"><span>125</span>分钟</div>
						</li>
						<li class="li3">
							<div class="tit">总获得积分</div>
							<div class="text"><span>206</span>积分</div>
						</li>
					</ul>
				</div>
				
				<div class="data_list">
					<div class="tits">
						学习时间柱状图
						<div class="name_list name_list1 fr">有效时长</div>
						<div class="name_list name_list2 fr">学习时长</div>
					</div>
					<div id="Chart" class="Chart"></div>
				</div>
			</div>
			
			<div class="details hide"> <!-- 详情 -->
				<div class="data_list">
					<div class="tits">
						同步课文学习详情
					</div>
					<div class="table">
						<el-table
							:height="200"
							:data="tableData"
							style="width: 100%">
							<el-table-column
								align="center"
								prop="date1"
								min-width="80"
								label="日期">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date2"
								min-width="80"
								label="课本">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date3"
								min-width="120"
								label="年级">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date4"
								min-width="80"
								label="单元">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date5"
								min-width="80"
								label="学习时长">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date6"
								min-width="80"
								label="有效时长">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date7"
								min-width="120"
								label="错误发音单词">
								<template slot-scope="scope">
									{{scope.row.date7}}
									<span class="btn" @click="checkwrongBlon = true">查看</span>
									<span class="btn">导出</span>
								</template>>
							</el-table-column>
							<el-table-column
								align="center"
								prop="date8"
								min-width="80"
								label="积分">
								<template slot-scope="scope">
									<span class="red">{{scope.row.date8}}</span>
								</template>>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :total="100">
					</el-pagination>
				</div>
				
				<div class="data_list">
					<div class="tits">
						同步句子学习详情
					</div>
					<div class="table">
						<el-table
							:height="200"
							:data="tableData2"
							style="width: 100%">
							<el-table-column
								align="center"
								prop="date1"
								min-width="80"
								label="日期">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date2"
								min-width="80"
								label="类型">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date3"
								min-width="80"
								label="学习时长">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date4"
								min-width="80"
								label="有效时长">
							</el-table-column>
							<el-table-column
								align="center"
								prop="date5"
								min-width="150"
								label="正确率">
								<template slot-scope="scope">
									{{scope.row.date5}}
									<span class="btn" @click="checkwrongBlons = true">查看</span>
									<span class="btn">导出</span>
								</template>
							</el-table-column>
							<el-table-column
								align="center"
								prop="date6"
								min-width="80"
								label="积分">
								<template slot-scope="scope">
									<span class="red">{{scope.row.date6}}</span>
								</template>>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :total="100">
					</el-pagination>
				</div>
			</div>
			
			<div class="Checkwrong hide" :class="checkwrongBlon?'on':''"> <!-- 同步课文查看错题弹窗 -->
				<div class="Checkcont">
					<div class="tits">查看错题<div class="btnGb" @click="checkwrongBlon = false"></div></div>
					<div class="cont" :style="{height: height+'px'}">
						<div class="titc clr">同步课文- 人教新课改 - 三年级上册  -  Unit2<span class="fr">答错 6 题</span></div>
						<div class="contct">
							<ul>
								<li class="lists">
									<div class="tit_list">
										<span class="nums">1.</span>
										<span class="red">friendly</span>
										<span class="xbt"></span>
									</div>
									<div class="tit_list">
										<span class="texts">He is very friendly.He is very friendly.</span>
										<span class="xbt"></span>
									</div>
								</li>
								<li class="lists">
									<div class="tit_list">
										<span class="nums">2.</span>
										<span class="red">friendly</span>
										<span class="xbt"></span>
									</div>
									<div class="tit_list">
										<span class="texts">He is very friendly.He is very friendly.</span>
										<span class="xbt"></span>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="btn_list">
						<div class="btn" @click="checkwrongBlon = false">关 闭</div>
					</div>
				</div>
			</div>
			
			<div class="Checkwrong hide" :class="checkwrongBlons?'on':''"> <!-- 同步句子查看错题弹窗 -->
				<div class="Checkcont">
					<div class="tits">查看错题<div class="btnGb" @click="checkwrongBlons = false"></div></div>
					<div class="cont" :style="{height: height+'px'}">
						<div class="titc clr">同步句子- 人教新课改 - 三年级上册  -  Unit2<span class="fr">答错 6 题</span></div>
						<div class="contct">
							<ul>
								<li class="listjz">
									<div class="ct_num fl">1.</div>
									<div class="ct_con">
										<div class="name">Here you are.</div>
										<div class="cor">Here you are </div>
										<div class="name">给你</div>
									</div>
								</li>
								<li class="listjz">
									<div class="ct_num fl">3.</div>
									<div class="ct_con">
										<div class="name">Oh,thank you!</div>
										<div class="cor">you Oh thank </div>
										<div class="name">哦，谢谢你。</div>
									</div>
								</li>
								<li class="listjz">
									<div class="ct_num fl">3.</div>
									<div class="ct_con">
										<div class="name">Oh,thank you!</div>
										<div class="cor">you Oh thank </div>
										<div class="name">哦，谢谢你。</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="btn_list">
						<div class="btn" @click="checkwrongBlons = false">关 闭</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>
<script>
export default {
  data(){
    return {
			height: null,
			checkwrongBlon: false,
			checkwrongBlons: false,
			tableData: [{
				date1: '06-10',
				date2: '人教版',
				date3: '七年级上册',
				date4: 'UNIT3',
				date5: '17分46秒',
				date6: '15分20秒',
				date7: '17个',
				date8: '+15',
			}, {
				date1: '06-10',
				date2: '人教版',
				date3: '七年级上册',
				date4: 'UNIT3',
				date5: '17分46秒',
				date6: '15分20秒',
				date7: '17个',
				date8: '+15',
			}],
			tableData2: [{
				date1: '06-10',
				date2: '句子听写',
				date3: '17分46秒',
				date4: '17分46秒',
				date5: '8/10  正确率80%',
				date6: '+15'
			},{
				date1: '06-10',
				date2: '句子听写',
				date3: '17分46秒',
				date4: '17分46秒',
				date5: '8/10  正确率80%',
				date6: '+15'
			}]
		};
	},
	created(){
		
	},
	methods:{
		Chart(){
			var that = this,myChart = that.$echarts.init(document.getElementById('Chart'));
			myChart.clear();
			// 绘制图表
			myChart.setOption({
				tooltip: {
					trigger: 'axis',
					axisPointer: { // 坐标轴指示器，坐标轴触发有效
						type: 'shadow'// 默认为直线，可选为：'line' | 'shadow'
					}
				},
				legend: { 
					left:'right',
					top: 0,
					data:[]//['学习时长','有效时长']
				},
				grid: {
					left: 10,
					right: 40,
					bottom: 0,
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						name: '日期',
						data: ['4/20','4/21','4/22','4/23','4/24','4/25','4/26','4/27','4/28','4/29','4/30','5/01']
					}
				],
				yAxis: [
					{
						type: 'value',
						name: '时间/分钟',
					}
				],
				series: [
					{
						name:'学习时长',
						type:'bar',
						stack: '日期',
						color: "#cccccc",
						data: [40,20,30,25,40,25,60,40,20,30,25,40]
					},
					{
						name:'有效时长',
						type:'bar',
						stack: '日期',
						color: "#4069fa",
						data: [50,20,30,25,50,25,60,40,20,30,25,40]
					},
				]
			});
		}
	},
	mounted(){
		var that = this;
		that.height = window.innerHeight - (450*that.utils.per());
		that.Chart();
	}
}
</script>
<style scoped>
	
</style>